import React, { Component } from 'react';
import ReceiptItem from "./ReceiptItem";
import { genericHelpers, currency } from './../../../../../helpers/';

const getMonthDiff = (start_date, end_date) => {
	const startDate = new Date(start_date), endDate = new Date(end_date);
	return endDate.getMonth() - startDate.getMonth() + (12 * (endDate.getFullYear() - startDate.getFullYear()));
};

class ReceiptBasket extends Component {

	item( item, type, name, description, diff, products ) {
		return (
			<div key={ item.id }>
				<ReceiptItem
					id={ item.id }
					type={ type }
					name={ name }
					description={ description }
					monthDiff={ diff }
					{ ...(products ? { packageProducts : products } : {}) } />
			</div>
		);
	}

	list() {
		return this.props.items.map( item => {
			if( item.package ){
				return this.item( item, "Package", item.package.name, item.package.description, getMonthDiff( item.start_date, item.end_date ), item.package.products );
			} else {
				return this.item( item, "Product", item.product.name, item.product.description, item.start_date && item.end_date ? getMonthDiff( item.start_date, item.end_date ) : null );
			};
		});
	}

	tax( vat ){
		if( (this.props.currency && this.props.currency.common_country_id === 77) || (!this.props.currency && genericHelpers.siteOfOriginHelper() === 'gb') ){
			return [
				<div key="1" className="col-xs-5 col-md-6 align-right">
					<p className="p-tag margin-none">{`${ currency.taxType() }:`}</p>
				</div>,
				<div key="2" className="col-xs-7 col-md-6 align-left">
					<p className="p-tag margin-none">{ currency.convert( vat, 'gb' ) }</p>
				</div>
			];
		};
	};

	render() {
		const vat = Math.round((this.props.price * 0.2) * 100) / 100;
		const total = Math.round((this.props.price + vat) * 100) / 100;

		const abbr = (this.props.currency && this.props.currency.common_country_id === 77) || (!this.props.currency && genericHelpers.siteOfOriginHelper() === 'gb') ? 'gb' : 'us' ;

		return (
			<div className="row">
				<div className="col-xs-12 col-md-8">
					{ this.list() }
				</div>
				<div className="col-xs-12 col-md-4">
					<div className="row">
						<div className="col-xs-5 col-md-6 align-right">
							<p className="p-tag margin-none"> Net:</p>
						</div>
						<div className="col-xs-7 col-md-6 align-left">
							<p className="p-tag margin-none">{ currency.convert( this.props.price, abbr ) }</p>
						</div>
						{ this.tax( vat ) }
						<div className="col-xs-5 col-md-6 padding-bottom align-right">
							<p className="p-tag margin-none">Total:</p>
						</div>
						<div className="col-xs-7 col-md-6 padding-bottom align-left">
							<p className="p-tag margin-none">{ currency.convert( total, abbr ) } </p>
						</div>
					</div>
				</div>
			</div>
		)
	}
};

export default ReceiptBasket;



// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/ReceiptBasket.js